/**
 * A marca nomeia o outro cartão para os dois poderem ser comparados.
 * Nunca bloqueia uma ação.
 */
import { TriangleAlert } from 'lucide-react';
import type { ProbableDuplicate } from '../../../sdk/@types/Revisao';
import { shortIdLabel } from './cartaoLinha';

export function rotuloDuplicado(duplicate: ProbableDuplicate): string {
  const partner = shortIdLabel(duplicate.shortId) ?? duplicate.cardId;
  return `Provável duplicado de ${partner}`;
}

export function contarDuplicados(
  rows: readonly { probableDuplicate?: ProbableDuplicate }[],
): number {
  return rows.reduce((total, row) => total + (row.probableDuplicate ? 1 : 0), 0);
}

export default function DuplicadoBadge({
  duplicate,
}: {
  duplicate: ProbableDuplicate;
}): JSX.Element {
  const rotulo = rotuloDuplicado(duplicate);

  return (
    <span
      title={rotulo}
      className="inline-flex max-w-full items-center gap-1 rounded-chip border border-warn/40 bg-warn/[0.12] px-2 py-0.5 text-xs font-medium text-warn-ink"
    >
      <TriangleAlert size={12} aria-hidden />
      <span className="min-w-0 break-words">{rotulo}</span>
    </span>
  );
}
